export function createEntity(typeName, fields) {
    return { typeName, fields };
}
//# sourceMappingURL=create-entity.js.map